document.addEventListener('DOMContentLoaded',()=>{
  const form=document.querySelector('#TruckOutfittersContact');
  if(!form)return;
  const request=form.querySelector('[data-request-type]');
  const vehicleFields=form.querySelector('[data-vehicle-fields]');
  const appointmentFields=form.querySelector('[data-appointment-fields]');
  const questionField=form.querySelector('[data-question-field]');
  const questionLabel=form.querySelector('[data-question-label]');
  const year=form.querySelector('[data-vehicle-year]');
  const make=form.querySelector('[data-vehicle-make]');
  const model=form.querySelector('[data-vehicle-model]');
  const makeField=form.querySelector('[data-make-field]');
  const modelField=form.querySelector('[data-model-field]');
  const models={
    Chevrolet:['Colorado','Silverado 1500','Silverado 2500HD','Silverado 3500HD','Suburban','Tahoe'],
    Ford:['Bronco','F-150','F-150 Lightning','F-250 Super Duty','F-350 Super Duty','Maverick','Ranger'],
    GMC:['Canyon','Sierra 1500','Sierra 2500HD','Sierra 3500HD','Yukon'],
    Jeep:['Gladiator','Grand Cherokee','Wrangler'],
    Nissan:['Frontier','Titan','Titan XD'],
    Ram:['1500','2500','3500'],
    Toyota:['4Runner','Tacoma','Tundra']
  };
  const setRequired=(container,on)=>container.querySelectorAll('[data-conditional-required]').forEach(field=>field.required=on&&!field.disabled);
  const hideVehicleSteps=()=>{
    make.value=''; model.innerHTML='<option value="">Select model</option>'; model.value='';
    make.disabled=true; model.disabled=true; makeField.hidden=true; modelField.hidden=true;
  };
  const updateRequest=()=>{
    const type=request.value;
    const showVehicle=['installation','fitment','availability'].includes(type);
    const showAppointment=type==='installation';
    vehicleFields.hidden=!showVehicle; appointmentFields.hidden=!showAppointment; questionField.hidden=!type;
    setRequired(vehicleFields,showVehicle); setRequired(appointmentFields,showAppointment); setRequired(questionField,!!type);
    questionLabel.textContent=type==='installation'?'What Would You Like Installed?':'Question';
    if(!showVehicle){year.value='';hideVehicleSteps();}
  };
  year.addEventListener('change',()=>{
    const show=!!year.value; makeField.hidden=!show; make.disabled=!show;
    if(show)make.required=true; else{make.required=false;hideVehicleSteps();}
  });
  make.addEventListener('change',()=>{
    model.innerHTML='<option value="">Select model</option>';
    (models[make.value]||[]).forEach(name=>model.add(new Option(name,name)));
    const show=!!make.value; modelField.hidden=!show; model.disabled=!show; model.required=show;
  });
  request.addEventListener('change',updateRequest);
  const applyContactIntent=()=>{
    const params=new URLSearchParams(window.location.search);
    if(params.get('request')==='installation'||window.location.hash==='#appointment'){
      request.value='installation';
      updateRequest();
    }
  };
  updateRequest();
  applyContactIntent();
  window.addEventListener('hashchange',applyContactIntent);
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');
    if(!link)return;
    const target=new URL(link.href,window.location.href);
    if(target.pathname===window.location.pathname&&target.hash==='#appointment'){
      request.value='installation';updateRequest();
    }
  });
});
